export interface IVideoSchema {
  name: string;
  description: string;
  thumbnailUrl: string;
  uploadDate: string;
  duration: string;
  embedUrl: string;
}

export const videoSchema = ({
  name,
  description,
  thumbnailUrl,
  uploadDate,
  duration,
  embedUrl,
}: IVideoSchema) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name,
    description,
    thumbnailUrl,
    uploadDate,
    duration,
    embedUrl,
  };
};
